import { render, staticRenderFns } from "./AboutProductWMSView.vue?vue&type=template&id=25513b46"
import script from "./AboutProductWMSView.vue?vue&type=script&lang=js"
export * from "./AboutProductWMSView.vue?vue&type=script&lang=js"
import style0 from "./AboutProductWMSView.vue?vue&type=style&index=0&id=25513b46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports